const childRoute = (prop) => [
    {
    path: 'dealer-allocation',
    name: prop + '.dealer_allocation',
    meta: { auth: true },
    component: () => import('../pages/dealer-allocation/List.vue')
  },
  {
    path: 'farmer-allocation',
    name: prop + '.farmer_allocation',
    meta: { auth: true },
    component: () => import('../pages/farmer-allocation/List.vue')
  },
  {
    path: 'variety-allocation',
    name: prop + '.variety_allocation',
    meta: { auth: true },
    component: () => import('../pages/variety_allocation/List.vue')
  },
  {
    path: 'variety-stock',
    name: prop + '.variety_stock',
    meta: { auth: true },
    component: () => import('../pages/variety_stock/List.vue')
  },
  {
    path: 'regional-variety-allocation',
    name: prop + '.regional_variety_allocation',
    meta: { auth: true },
    component: () => import('../pages/regional-variety-allocation/List.vue')
  },
  {
    path: 'dealer-payment-list',
    name: prop + '.dealer_payment_list',
    meta: { auth: true },
    component: () => import('../pages/dealer-payment/List.vue')
  },
  {
    path: 'farmer-payment-list',
    name: prop + '.farmer_payment_list',
    meta: { auth: true },
    component: () => import('../pages/farmer-payment/List.vue')
  }
]
const routes = [
  {
    path: '/seeds-fertilizer-service/seeds-badc-sales',
    name: 'seeds_fertilizer_service.seeds-badc-sales',
    component: () => import('@/layouts/SeedsFertilizerLayout'),
    meta: { auth: true },
    children: childRoute('seeds_fertilizer_service.seeds-badc-sales')
  }
]

export default routes
